import { render } from "./ExerciseItems.vue?vue&type=template&id=3cfaf846&scoped=true"
import script from "./ExerciseItems.vue?vue&type=script&lang=js"
export * from "./ExerciseItems.vue?vue&type=script&lang=js"

import "./ExerciseItems.vue?vue&type=style&index=0&id=3cfaf846&lang=less&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3cfaf846"]])

export default __exports__